import { MOBILE_CANVAS_MAX_SIZE } from '../configs';

const applyMobileCanvasSizeLimit = (width: number, height: number) => {
  const canvasArea = width * height;
  const maxCanvasSizeSquared = MOBILE_CANVAS_MAX_SIZE ** 2;

  if (canvasArea > maxCanvasSizeSquared) {
    const imgBigSide = Math.max(width, height);
    const scaleFactor = imgBigSide / MOBILE_CANVAS_MAX_SIZE;
    const scaledWidth = Math.round(width / scaleFactor);
    const scaledHeight = Math.round(height / scaleFactor);

    return { width: scaledWidth, height: scaledHeight };
  }

  return { width, height };
};

export default applyMobileCanvasSizeLimit;
